import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Make sure to import the useAuth hook

export default function NavBar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login'); // Redirect to login after logout
        } catch (error) {
            console.error("Logout failed:", error);
            alert("Failed to logout. Please try again.");
        }
    };

    return (
        <nav className="navbar navbar-expand navbar-dark bg-dark">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">Dashboard</Link>
                <div className="ms-auto"> {/* Removed collapsible button and related div */}
                    {user ? (
                        <button onClick={handleLogout} className="btn btn-link nav-link text-white">Logout</button>
                    ) : (
                        <Link className="btn btn-link nav-link text-white" to="/login">Login</Link>
                    )}
                </div>
            </div>
        </nav>
    );
}
